/* eslint-disable import/prefer-default-export */
export const LAST_SELECTED_SHOP_LOCALSTORAGE_KEY = '__last_selected_shop__';
